import React from 'react';
import './style.scss';

function Hamburger({ active, toggle }) {
    return (
        <button className={`mobile-hamburger ${active ? 'active' : ''}`} onClick={() => toggle(!active)} />
    )
}
export default Hamburger
